import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="file-upload"
export default class extends Controller {
    static targets = ["label", "text", "submitbutton"]

    connect() {}

    change({ currentTarget }) {
        const datei = Array.from(currentTarget.files)[0]

        this.textTarget.textContent = datei.name
        this.labelTarget.classList.remove("*:fill-gray-300")
        this.labelTarget.classList.add("*:fill-highlight")

        this.submitbuttonTarget.classList.remove("button_disabled_wide")
        this.submitbuttonTarget.classList.add("button_primary_wide")
        this.submitbuttonTarget.removeAttribute("disabled")
    }
}
